<block-ui>
    <form class="row mb-3" [formGroup]="SearchForm">
        <div class="col">
            <label class="">Cédula:</label>
            <input type="text" class="form-control form-control-sm" formControlName="Card" (change)="LoadPeoplePagedCount()">
        </div>
        <div class="col">
            <label class="">Nombre:</label>
            <input type="text" class="form-control form-control-sm" formControlName="Filter" (change)="LoadPeoplePagedCount()">
        </div>
        <div class="col">
            <label class="">Actualización desde:</label>
            <input type="date" class="form-control form-control-sm" formControlName="From" (change)="ValidateDate('From')" (blur)="(search)?LoadPeoplePagedCount():false">
        </div>
        <div class="col">
            <label class="">Actualización hasta:</label>
            <input type="date" class="form-control form-control-sm" formControlName="To" (change)="ValidateDate('To')" (blur)="(search)?LoadPeoplePagedCount():false">
        </div>
        <div class="d-flex align-items-end mr-3">
            <div class="d-flex flex-row-reverse">
                <button type="button" class="btn btn-light shadow-sm btn-sm" (click)="LoadPeoplePagedCount()">Buscar</button>
            </div>
        </div>
    </form>
    <div class="tableFixHead mt-2">
        <table class="table table-striped table-sm">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col" style="position: sticky; top: 0;">#</th>
                    <th scope="col" style="position: sticky; top: 0;">Cédula</th>
                    <th scope="col" style="position: sticky; top: 0;">Nombre</th>
                    <th scope="col" style="position: sticky; top: 0;">Edad</th>
                    <th scope="col" style="position: sticky; top: 0;">Actualizado</th>
                    <th scope="col" style="position: sticky; top: 0;"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let person of people; index as i;">
                    <td>{{(i + 1 + ((CurrentPage-1)*PageSize))}}</td>
                    <td>{{person.Card}}</td>
                    <td>{{person.Name}}</td>
                    <td>{{person.Years}} años</td>
                    <td>{{person.UpdateDate | date: 'dd/MM/YYYY hh:mm'}}</td>
                    <td class="d-flex justify-content-left">
                        <button class="btn btn-sm btm-primary shadow-sm mx-1 my-1" (click)="openPersonInfo(modalPersonInfo, person)">
                            <fa-icon class="fa" icon="info-circle"></fa-icon>
                        </button>
                        <button *ngIf="person.Vehicles.length" class="btn btn-sm btm-primary shadow-sm mx-1 my-1" (click)="openVehicles(modalVehicles, person)">
                            <fa-icon class="fa" icon="car"></fa-icon>
                        </button>
                        <button *ngIf="person.Properties.length" class="btn btn-sm btm-primary shadow-sm mx-1 my-1" (click)="openProperties(modalProperties, person)">
                            <fa-icon class="fa" icon="home"></fa-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <ngb-pagination class="col d-flex justify-content-center mt-2" [collectionSize]="CollectionSize" [pageSize]="PageSize" [(page)]="CurrentPage" [boundaryLinks]="true" (pageChange)="LoadPeople()">
            <ng-template ngbPaginationPages let-page let-pages="pages">
                <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                    <div class="form-group d-flex flex-nowrap px-2">
                        <label id="paginationInputLabel" for="paginationInput" class="col-form-label mr-2 ml-1">Página</label>
                        <input #i type="text" inputmode="numeric" pattern="[0-9]*" class="form-control custom-pages-input" id="paginationInput" [value]="CurrentPage" (keyup.enter)="SelectPage(i.value)" (blur)="SelectPage(i.value)" (change)="LoadPeople()" (input)="FormatInput($any($event).target)"
                            aria-labelledby="paginationInputLabel paginationDescription" />
                        <span id="paginationDescription" class="col-form-label text-nowrap px-2">
                          de {{pages.length}}</span>
                    </div>
                </li>
            </ng-template>
        </ngb-pagination>
    </div>
</block-ui>

<!-- More info Modal -->
<ng-template #modalPersonInfo let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Datos de la persona</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="personSelected">
            <div class="col-12">
                <strong>Nombre: </strong>{{personSelected.Name}}
            </div>
            <div class="col-12">
                <strong>Profesión: </strong>{{personSelected.Profession}}
            </div>
            <div class="col-12">
                <strong>Correos: </strong>{{personSelected.Emails}}
            </div>
            <div class="col-12">
                <strong>Número de telefono: </strong>{{personSelected.PhoneNumbers}}
            </div>
            <div class="col-12">
                <strong>Dirección: </strong>{{personSelected.Address}}
            </div>
            <div class="col-12">
                <strong>Estado civil: </strong>{{personSelected.CivilStatus}}
            </div>
            <div class="col-12">
                <strong>Posibles hijos: </strong>{{personSelected.PossibleChildrens}}
            </div>
            <div class="col-12">
                <strong>Posibles hermanos: </strong>{{personSelected.PossibleSiblings}}
            </div>
            <div class="col-12">
                <strong>Sociedades: </strong>{{personSelected.Societies}}
            </div>
            <div class="col-12">
                <strong>Referencias crediticias: </strong>{{personSelected.CreditReferences}}
            </div>
            <div class="col-12">
                <strong>Prendas e hipotecas: </strong>{{personSelected.PledgesMortgages}}
            </div>
            <div class="col-12">
                <strong>Procesos judiciales: </strong>{{personSelected.JudicialProcesses}}
            </div>
            <div class="col-12">
                <strong>Último patrono: </strong>{{personSelected.LastEmployer}}
            </div>
            <div class="col-12">
                <strong>Último salario registrado: </strong>{{personSelected.SalaryRange}}
            </div>
            <div class="col-12">
                <strong>Último periodo salarial: </strong>{{personSelected.LastPeriod}}
            </div>
            <div class="col-12">
                <strong>Estado actualización empleo: </strong>{{personSelected.EmploymentUpdate}}
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Cerrar</button>
    </div>
</ng-template>

<!-- Vehicles Modal -->
<ng-template #modalVehicles let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Vehículos</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="vehiclesSelected">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead style="background-color: #172749; color: white;">
                        <tr>
                            <th>Placa</th>
                            <th>Marca</th>
                            <th>Estilo</th>
                            <th>Año</th>
                            <th>Valor fiscal</th>
                            <th>Gravamenes</th>
                            <th>Levantamientos</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let vehicle of vehiclesSelected">
                            <td>{{vehicle.CardPlate}}</td>
                            <td>{{vehicle.Brand}}</td>
                            <td>{{vehicle.Style}}</td>
                            <td>{{vehicle.Year}}</td>
                            <td>{{vehicle.TaxValue}}</td>
                            <td>{{vehicle.Liens}}</td>
                            <td>{{vehicle.Lifts}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Cerrar</button>
    </div>
</ng-template>

<!-- Properties Modal -->
<ng-template #modalProperties let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Propiedades</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="propertiesSelected">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead style="background-color: #172749; color: white;">
                        <tr>
                            <th>Finca</th>
                            <th>Plano</th>
                            <th>Valor fiscal</th>
                            <th>Dirección</th>
                            <th>Gravamenes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let property of propertiesSelected">
                            <td>{{property.PropertyNumber}}</td>
                            <td>{{property.Plan}}</td>
                            <td>{{property.TaxValue}}</td>
                            <td>{{property.Address}}</td>
                            <td>{{property.Liens}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Cerrar</button>
    </div>
</ng-template>